import React from "react"
import PropTypes from "prop-types"
import { useHistory } from "react-router"

import BookingDetail from "./BookingDetail"
import { reverse, buildRouteFromLocation } from "utils/urls"

export default function TourOperatorBookingDetail(props) {
  let history = useHistory()

  return (
    <BookingDetail
      detailEndpoint={`/bookings/tour-operator-bookings/${props.match.params.id}/`}
      listRoute={reverse("tourOperatorBookingList")}
      changeRoute={reverse(
        "tourOperatorBookingUpdate",
        {
          id: props.match.params.id,
        },
        { next: buildRouteFromLocation(history.location) }
      )}
      deleteRoute={reverse(
        "tourOperatorBookingDelete",
        {
          id: props.match.params.id,
        },
        {
          next:
            encodeURIComponent(
              new URLSearchParams(history.location.search).get("next")
            ) || reverse("tourOperatorBookingList"),
        }
      )}
    />
  )
}

TourOperatorBookingDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
